<template>
    <div>
        <div class="center" :class="$style.title">
            <logo></logo>
        </div>
        <div :class="$style.content">
            <h1 class="center fs32">Personal Information Collection Statement</h1>
            <div>
                <h2 :class="$style.fs">Use of personal data</h2>
                <p>During the term of business operation, the personal data collected by Golden Win may be electronically or manually processed/used by Pearson for the following purpose within the jurisdictions in which Pearson and/or data processors conduct businesses:</p>
            </div>
            <div>
                <h2 :class="$style.fs">Processing your orders for products of Pearson;</h2>
                <h2 :class="$style.fs">Processing your registration or order for services of Pearson;</h2>
            </div>
            <div>
                1. Processing your orders for products of Golden Win;<br>
                2. Processing your registration or order for services of Golden Win;<br>
                3. Verifying your identity for access to private contents of Golden Win's website or event of Pearson or for participating in activities of Pearson;<br>
                4. Research and customer survey;<br>
                5. Processing your application for membership of the Golden Win Fan Club;
                6. Billing and debt collection;<br>
                7. Dealing with your suggestion, enquiry and complaint;<br>
                8. Communicating with you generally;<br>
                9. Subject to the provisions of applicable laws to direct market Golden Win's products and services to you.
            </div>
            <div>
                <h2 :class="$style.fs">Transfer of Personal Data</h2>
                <p>Your personal data held by Golden Win will be kept confidential, but Golden Win may transfer your persoanl data to a data processor(e.g. printer, production house, providers of mailing serivces, cloud servers, storage providers, or a third party who powers Golden Win's product) engaged by Golden Win to process or handle personal data on its behalf, Subject to a duty of confidentiality.</p>
            </div>
            <div>Because the internet is a global environment, you accept and agree that this will include the transfer of your personal information to other countries and regions around the world, including Japan, India, Middle East, UK, USA, Canada, Singapore, Australa, Philippines, China(including Mainland China, Hong Kong, Macao and Taiwan), Egypt, and European Economic Area.</div>
            <div>
                <h2 :class="$style.fs">Rights of Access and Correction to Data Collected</h2>
                <p>You have a right to (i) request access to; (ii) obtain a copy of; (iii) supplement or request correction of; (iv) request that Pearson cease the collection, processing, or use of; or (v) request that Pearson delete your personal data held by Pearson. If you wish to exercise your rights, please contact Golden Win's Data Protection Officer by email at goldenwin3063@gmail.com; Golden Win will not charge you any fes with this regards.</p>
            </div>
            <div>This Statement may be revised form time to time. If there is any inconsistency between the English and Chinese version of this Statement, the English version shall prevail.</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'TermPersonal',
    created() {
        this.$top();
    }
}
</script>
<style module>
.content {
    margin: 100px auto;
    width: 70%;
}
.content > div {
    margin-top: 40px;
}
.title {
    margin: 100px;
}
@media screen and (max-width: 770px) {
    .title {
        margin: 30px auto;
    }
    .content {
        margin: 0px 0px 30px 0px;
        padding: 0px 30px;
        width: 100%;
    }
     .content > div {
        margin-top: 30px;
    }
    .fs {
        font-size: 16px;
    }
}
</style>
